<script>
	export let title = "Expand icon";
</script>

<style></style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.45 52.45" role="img">
	<title>{title}</title>
	<path
		d="M.75,27.8H.75l6.22,6.22c.84,.84,2.22,.85,3.06,0,.84-.85,.84-2.22,0-3.06l-2.52-2.52H23.95v16.44l-2.52-2.52c-.84-.84-2.22-.84-3.07,0-.84,.85-.84,2.22,0,3.07l6.22,6.22h0c.83,.84,2.23,.84,3.06,0h0l6.22-6.22c.85-.84,.85-2.22,0-3.07-.84-.84-2.22-.84-3.06,0l-2.52,2.52V28.44h16.44l-2.52,2.52c-.85,.84-.85,2.22,0,3.06,.85,.85,2.23,.84,3.06,0l6.22-6.22c.83-.84,.85-2.19,0-3.06l-6.22-6.22c-.84-.85-2.22-.85-3.06,0-.85,.85-.85,2.22,0,3.06l2.52,2.52H28.29V7.66l2.52,2.52c.84,.84,2.22,.85,3.06,0,.85-.84,.85-2.22,0-3.06L27.65,.9h0c-.87-.86-2.25-.82-3.06,0h0l-6.22,6.22c-.84,.84-.84,2.22,0,3.06,.85,.85,2.22,.85,3.07,0l2.52-2.52V24.1H7.52l2.52-2.52c.84-.85,.84-2.22,0-3.06-.85-.85-2.22-.85-3.06,0L.75,24.73c-.85,.84-.83,2.26,0,3.06" />
</svg>
